import { COLORS } from 'consts/colors'
import { Z_INDEX_FOR_HIDE_REACT_SELECTO_RECTANGLE_DURING_SCROLL } from 'consts/zIndex'
import styled from 'styled-components'

export const ResizeLineWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  cursor: row-resize;
  height: 16px;
  transform: translateY(-50%);
  width: 100%;
  z-index: ${Z_INDEX_FOR_HIDE_REACT_SELECTO_RECTANGLE_DURING_SCROLL};
  transition: opacity 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    width: 100%;
    height: 1px;
    background-color: ${COLORS.primaryDark};
    opacity: 0;
  }

  &:hover {
    &::after {
      opacity: 1;
    }
  }
`

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 280px;
  flex-shrink: 0;
  border-top: 1px solid ${COLORS.borderColor};
  box-sizing: border-box;
`
